import { Grid, Card, CardContent, CardHeader } from '@mui/material';

import { InfoField, Typography } from '@occc-app/design-system';
import { LocationAddressFragment } from '@occc/graphql';
import { FormattedScheduleListItem } from '@occc-app/lib/util-location-schedule';

import { LocationScheduleCard } from '../location-schedule-card';
import { LocationAddressCard } from '../location-address-card';
import { LocationAttributesCard } from '../location-attributes-card';

type LocationGeneralInfoCardProps = {
  name?: string | null;
  address?: LocationAddressFragment | null;
  phoneNumbers: string[];
  schedule: FormattedScheduleListItem[];
  attributes: string[];
};

export const LocationGeneralInfoCard = ({
  name,
  address,
  phoneNumbers,
  schedule,
  attributes,
}: LocationGeneralInfoCardProps) => {
  return (
    <Card sx={{ mb: 3 }}>
      <CardHeader title={<Typography variant='h6'>Store Details</Typography>} />
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <InfoField sx={{ m: 0 }} label='Location Name' value={name} noDataMessage='' />
          </Grid>
          <LocationAddressCard address={address} phoneNumbers={phoneNumbers} />
          <LocationAttributesCard attributes={attributes} />
          <LocationScheduleCard schedule={schedule} />
        </Grid>
      </CardContent>
    </Card>
  );
};
